import React from 'react';
import { getCanonicalSearchUrl } from '@eb/redux-destination';

import {
    FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP,
    SEO_FRIENDLY_FILTERS,
} from '../../../../SearchApp/constants';

const seoFriendlyEventSearch = SEO_FRIENDLY_FILTERS.reduce((memo, key) => {
    memo[key] = '';

    return memo;
}, {});

const removeUnlinkableValues = (values) =>
    values.filter(
        ({ value }) =>
            value &&
            ['custom_date', 'paid', 'clearPrice'].indexOf(value) === -1,
    );

const FilterLinks = ({ values, filterType, slug }) => {
    const filteredValues = removeUnlinkableValues(values);
    const links = filteredValues.map(({ value, display }) => {
        let formattedEventSearch = seoFriendlyEventSearch;

        if (filterType === 'tags' || filterType === 'format') {
            formattedEventSearch = {
                ...seoFriendlyEventSearch,
                tags: [...seoFriendlyEventSearch.tags, value],
            };
        } else {
            formattedEventSearch = {
                ...seoFriendlyEventSearch,
                [filterType]: value,
            };
        }

        const path = getCanonicalSearchUrl({
            ...formattedEventSearch,
            slug,
        });

        return { href: path, display };
    });

    return (
        <ul>
            {links.map(({ href, display }) => (
                <li key={href}>
                    <a href={href}>{display}</a>
                </li>
            ))}
        </ul>
    );
};

export const BotFilters = (props) => (
    <section data-testid="bot-friendly-filters">
        {SEO_FRIENDLY_FILTERS.map((filterType) => {
            const heading =
                FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP[filterType].label;
            const values =
                FACETED_SEARCH_DROPDOWN_FILTER_PROP_MAP[filterType].values;

            return (
                <div key={heading} data-testid="bot-friendly-filter--heading">
                    <section>{heading}</section>
                    <FilterLinks
                        values={values}
                        filterType={filterType}
                        slug={props.slug}
                    />
                </div>
            );
        })}
    </section>
);

export default BotFilters;
